import React, { useState, useEffect } from 'react';
import './Slideshow.css';

const images = [
    'IMG_1301.jpg',
    'IMG_1322.jpg',
    'IMG_1323.jpg',
    'IMG_1326.jpg',
    'IMG_1337.jpg',
    'IMG_1338.jpg',
    'IMG_1339.jpg'
];

const ChurchSlideshow = () => {
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
        }, 5000); // Change image every 5 seconds
        return () => clearInterval(interval);
    }, []);

    return (
        <div className='slideshow-container'>
            {images.map((image, index) => (
                <div
                    key={index}
                    className={`slide ${index === currentIndex ? 'active' : ''}`}
                    style={{ backgroundImage: `url(${image})` }}
                />
            ))}
        </div>
    );
};

export default ChurchSlideshow;
